import {DAYS} from "@/common/constants";
import dayjs from "dayjs";

export const afterLabel = schedule => {
    const [type, after] = schedule.condition.split(',');
    if (type !== 'after') return;

    const [hours, minutes] = after.split(':');

    const time = [[
        hours.padStart(2, '0'), '시간'
    ], [
        minutes.padStart(2, '0'), '분'
    ]].filter(([v]) => v !== '00')
        .map(([v, l]) => [v.replace(/^0(\d)/, '$1'), l])
        .map(v => v.join(''))
        .join(' ');

    return `${time} 뒤`;
};

export const atLabel = schedule => {
    const [type, at, days] = schedule.condition.split(',');
    if (type !== 'at') return;

    const [hours, minutes] = at.split(':');
    const codes = days && days.split('|') || [];

    const dayText = DAYS.filter(({code}) => codes.includes(code)).map(({name}) => name).join(', ');

    return [
        0 === dayText.length ? '' : codes.length === DAYS.length ? '매일' : `매주 ${dayText}`,
        [`${hours}시`, minutes !== '0' && `${minutes}분`]
            .filter(v => v).join(' ')
    ].filter(v => v).join(' ');
};

export const contentDeviceText = schedule => {
    const [firstDevice] = schedule.devices;
    return 1 < schedule.devices.length
        ? `[${firstDevice.name}] 외 ${schedule.devices.length - 1}`
        : `[${firstDevice.name}]`;
}

export const contentText = schedule => {
    const [firstDevice] = schedule.devices;
    const deviceText = 1 < schedule.devices.length
        ? `[${firstDevice.name}] 외 ${schedule.devices.length - 1}`
        : `[${firstDevice.name}]`;
    const commandText = schedule.commands.map(({name}) => name).join(', ');
    return [deviceText, commandText].join(', ');
};

export const wrapDebug = debug => message => debug(`${dayjs().format('YYYY-MM-DD HH:mm:ss')}: ${message}`);
